import { render, staticRenderFns } from "./ReportFittingInfo.vue?vue&type=template&id=6ed12f4b&scoped=true"
import script from "./ReportFittingInfo.vue?vue&type=script&lang=js"
export * from "./ReportFittingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed12f4b",
  null
  
)

export default component.exports